// These are hardcoded for the team/:slug path to know which id to send to Greenhouse's API
// Department template:
//
// 'department-slug': {
//   id: 123, // Greenhouse ID
//   name: 'HUMAN READABLE DEPARTMENT NAME',
//   enabled: true,
//   blogAPIUrl: 'https://www.nerdwallet.com/blog/wp-json/...', // Optional
// }

export default {
  administration: {
    id: 59365,
    name: 'Administration',
    backgroundClassName: 'admin-hero',
    body:
      'We support executive operations to move the needle on business strategy and objectives.',
    bodyMobile:
      'We support executive operations to move the needle on business strategy and objectives.',
    enabled: true,
  },
  business: {
    id: 67312,
    name: 'Business',
    backgroundClassName: 'business-hero',
    body:
      'We partner with our various business units to drive strategic initiatives and set the future direction of NerdWallet.',
    bodyMobile:
      'We partner with our various business units to drive strategic initiatives and set the future direction of NerdWallet.',
    enabled: true,
  },
  communications: {
    id: 1954,
    name: 'Communications',
    backgroundClassName: 'communications-hero',
    body:
      'We cut through the noise to tell the NerdWallet story - sharing our insights and expertise to help people make better financial decisions.',
    bodyMobile:
      'We cut through the noise to tell the NerdWallet story - sharing our insights and expertise to help people make better financial decisions.',
    enabled: true,
  },
  'compliance-and-legal': {
    id: 30421,
    name: 'Compliance and Legal',
    backgroundClassName: 'compliance-legal-hero',
    body:
      "We stay on top of the legal and compliance environment so we can support the company's strategy and deliver great products to consumers.",
    bodyMobile:
      "We stay on top of the legal and compliance environment so we can support the company's strategy and deliver great products to consumers.",
    enabled: true,
    opacityLevel: 0.75,
  },
  content: {
    id: 1705,
    name: 'Content',
    backgroundClassName: 'content-hero',
    body:
      'We help people lead richer lives by creating content that makes complex financial decisions easier to understand.',
    bodyMobile:
      'We help people lead richer lives by creating content that makes complex financial decisions easier to understand.',
    enabled: true,
  },
  data: {
    id: 53736,
    name: 'Data',
    backgroundClassName: 'data-hero',
    body:
      'We uncover the insights, models and data that help Nerds\nbuild products people love.',
    bodyMobile:
      'We uncover the insights, models and data that help Nerds build products people love.',
    enabled: true,
    opacityLevel: 0.7,
  },
  'design-and-user-experience': {
    id: 2212,
    name: 'Design and User Experience',
    backgroundClassName: 'design-page-hero',
    body:
      "We're designing the future of FinTech by rethinking consumer relationships and creating delightful experiences for our users.",
    bodyMobile:
      "We're designing the future of FinTech by rethinking consumer relationships and creating delightful experiences for our users.",
    enabled: true,
  },
  engineering: {
    id: 1703,
    name: 'Engineering',
    blogAPIUrl: 'https://www.nerdwallet.com/blog/wp-json/wp/v2/engineering/',
    backgroundClassName: 'engineering-hero',
    body:
      "We're building the data infrastructure and consumer applications that support our core business and developing products.",
    bodyMobile:
      "We're building the data infrastructure and consumer applications that support our core business and developing products.",
    enabled: true,
    opacityLevel: 0.7,
  },
  'finance-and-accounting': {
    id: 17243,
    name: 'Finance and Accounting',
    backgroundClassName: 'finance-hero',
    body:
      "We're all about finances. From profits to forecasting, our team aggregates the company's financial information.",
    bodyMobile:
      "We're all about finances. From profits to forecasting, our team aggregates the company's financial information.",
    enabled: true,
  },
  it: {
    id: 17835,
    name: 'Information Technology',
    backgroundClassName: 'it-hero',
    body:
      "We're redefining the next generation of IT services - supporting a fast growing company while building innovative cloud infrastructure.",
    bodyMobile:
      "We're redefining the next generation of IT services - supporting a fast growing company while building innovative cloud infrastructure.",
    enabled: true,
    opacityLevel: 0.65,
  },
  marketing: {
    id: 1704,
    name: 'Marketing',
    backgroundClassName: 'marketing-hero',
    body:
      'We use data-driven and creative inputs to develop growth strategies aimed at expanding our reach and building trust.',
    bodyMobile:
      'We use data-driven and creative inputs to develop growth strategies aimed at expanding our reach and building trust.',
    enabled: true,
    opacityLevel: 0.7,
  },
  'people-operations': {
    id: 1952,
    name: 'People Operations',
    backgroundClassName: 'peopleops-hero',
    body:
      "We're committed to developing an environment that encourages growth and provides a clear path for success.",
    bodyMobile:
      "We're committed to developing an environment that encourages growth and provides a clear path for success.",
    enabled: true,
    opacityLevel: 0.65,
  },
  'product-management': {
    id: 1950,
    name: 'Product Management',
    backgroundClassName: 'product-mgmt-hero',
    body:
      "We're problem solvers at heart. And when we see problems that need solutions, we build engaging products and experiences that meet those needs.",
    bodyMobile:
      "We're problem solvers at heart. And when we see problems that need solutions, we build engaging products and experiences that meet those needs.",
    enabled: true,
    opacityLevel: 0.7,
  },
  sales: {
    id: 71486,
    name: 'Sales',
    backgroundClassName: 'sales-hero',
    body:
      'We work with entrepreneurs across the country to help them to determine the right financing options for their business.',
    bodyMobile:
      'We work with entrepreneurs across the country to help them to determine the right financing options for their business.',
    enabled: true,
    opacityLevel: 0.7,
  },
  'user-operations': {
    id: 4352,
    name: 'User Operations',
    backgroundClassName: 'userops-hero',
    body:
      'We make sure our users have a delightful on-site experience and represent their voice to all of the teams.',
    bodyMobile:
      'We make sure our users have a delightful on-site experience and represent their voice to all of the teams.',
    enabled: true,
  },
};
